
export const getters = {
  kurs:state=>{
  return state.kurs
  },
  singlpk:state=>{
  return state.singlpk
  },
  kategorije:state=>{
  return state.kategorije
  },
  poruceno:state=>{
  return state.poruceno
  },
  podkategorije:state=>{
  return state.podkategorije
  },
  ppkategorije:state=>{
  return state.ppkategorije
  },
  showterms:state=>{
  return state.terms
  },
  showkat:state=>{
    return state.kat
  },
  naziv:state=>{
    return state.naziv
  },
  pro:state=>{
    return state.pro
  },
  allpro:state=>{
    return state.allpro
  },
  allpak:state=>{
    return state.allpak
  },
  prourl:state=>{
    return state.prourl
  },
  proprourl:state=>{
    return state.proprourl
  },
  propics:state=>{
    return state.propics
  },
  pojedinacna:state=>{
    return state.pojedinacna
  },
  pak:state=>{
    return state.pak
  },
  pakname:state=>{
    return state.pakname
  },
  showmanufectur:state=>{
    return state.manufectur
  },
  brand:state=>{
    return state.brand
  },
  brandurl:state=>{
    return state.brandurl
  },
  katurl:state=>{
    return state.katurl
  },
  podkaturl:state=>{
    return state.podkaturl
  },
  testurl:state=>{
    return state.testurl
  },
  saveturl:state=>{
    return state.saveturl
  },
  getproname:state=>{
    return state.proname
  },
  getopis:state=>{
    return state.opis
  },
  getsavet:state=>{
    return state.savet
  },
  getsaveti:state=>{
    return state.saveti
  },
  gettestiranja:state=>{
    return state.testiranja
  },
  gettest:state=>{
    return state.test
  },
  getsliketest:state=>{
    return state.sliketest
  },
  showprava:state=>{
  return state.prava
  },
  showuslovi:state=>{
  return state.uslovi
  },
  edit:state=>{
  return state.edit
  },
  singlpro:state=>{
  return state.singlpro
  },
  singlpics:state=>{
  return state.singlpics
  },
// concern:state=>{
// return state.concern
// },
// categories:state=>{
// return state.categories
// },
// ml:state=>{
// return state.ml
// },
// mlname:state=>{
//   return state.mlname
// },
// proizvodi:state=>{
// return state.proizvodi
// },
// preporuka:state=>{
//   return state.preporuka
// },
// singlpro:state=>{
// return state.singlpro
// },
// singl:state=>{
//   return state.singl
// },
cart:state=>{
  return state.cart
},
gettotal:state=>{
  return state.total
},
getsubtotal:state=>{
  return state.subtotal
},
getshipping:state=>{
  return state.shipping
},
//
// urlproduct:state=>{
// return state.urlproduct
// },
// lang:state=>{
// return state.lang
// },
// error:state=>{
// return state.error
// },
getlogin:state=>{
   return state.login
 },
//  getsid:state=>{
//    return state.sid
//  },
//  getsearch:state=>{
//    return state.search
//  }
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js